import React, { useState, useEffect, useRef, FC } from 'react'
import styled from 'styled-components'
import PageSection from 'components/PageSection'
import { useWeb3React } from '@web3-react/core/core/core'
import useTheme from 'hooks/useTheme' 
import { Carousel } from '@ape.swap/uikit' 
import { ArrowBackIcon, BaseLayout, Box, Button, Flex, Heading, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import YoutubeEmbed from 'views/Home/components/YoutubeEmbed' 
import {cakeSectionData } from './components/SalesSection/data'
import { cakeSectionData2 } from './components/SalesSection2/data'
import  TopTokenMovers3  from './components/TopTokenMovers3'
import SalesSection from './components/SalesSection'
import SalesSection3 from './components/SalesSection3'
import SalesSection4 from './components/SalesSection4'
import SalesSection5 from './components/SalesSection5'
import SalesSection0 from './components/SalesSection0'
import HVIDataRow2 from './components/HVIDataRow2'
import FarmsPoolsRow from './components/FarmsPoolsRow'
import Footer3 from './components/Footer3'
import FarmsPoolsRowLoader from './components/FarmsPoolsRowLoader'
import Chart from './components/YoutubeEmbed2' 
import RoadmapSlider from './Roadmap'  
 
const RightContent = styled.div`
  ${({ theme }) => theme.mediaQueries.md} {
    width: 50%;
  }
`;
const StyledText = styled(Text)` 
  text-align: center;
  font-size: 14px;
  font-weight: 500; 
  line-height: 24px;

  ${({ theme }) => theme.mediaQueries.md} {
    text-align: left;
  }
`
const StyledHeroSection = styled(PageSection)`
  padding-top: 0px;

  ${({ theme }) => theme.mediaQueries.md} {
    padding-top: 0px;
  }
`

const Cards2 = styled(BaseLayout)`
align-items: stretch;
justify-content: stretch;
grid-gap: 24px;
margin-top: -12px;
border-radius: 8px;
background-color: ${({ theme }) => theme.colors.backgroundAlt};
border: 1px solid ${({ theme }) => theme.colors.cardBorder};

& > div {
  grid-column: span 6;
  width: 100%;
  border-radius: 8px;
}

${({ theme }) => theme.mediaQueries.sm} {
  border-radius: 8px;
  margin-top: -12px;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  & > div {
    grid-column: span 8;
      border-radius: 8px;

  }
}

${({ theme }) => theme.mediaQueries.lg} {
  grid-gap: 32px;
  border-radius: 8px;
  margin-top: -12px;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  & > div {
    grid-column: span 6;
    border-radius: 8px;

  }
}

${({ theme }) => theme.mediaQueries.md} {
  grid-gap: 32px;
  border-radius: 8px;
  margin-top: -12px;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  & > div {
    grid-column: span 6;
    border-radius: 8px;

  }
}
`
const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  overflow: hidden;
   border-radius: 10px;
`

const SliderWrapper = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
`

const Slide = styled.div`
  min-width: 100%;
  box-sizing: border-box;
`

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s, transform 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
    transform: translateY(-50%) scale(1.1);
  }

  &:focus {
    outline: none;
  }

  &.next {
    right: 10px;
  }
`;
const Cards = styled(BaseLayout)`
align-items: stretch;
justify-content: stretch;
grid-gap: 24px;
margin-top: -50px;



& > div {
  grid-column: span 6;
  width: 100%;
  border-radius: 8px;
}

${({ theme }) => theme.mediaQueries.sm} {
  margin-top: -50px;

  & > div {
    grid-column: span 8;
      border-radius: 8px;

  }
}

${({ theme }) => theme.mediaQueries.lg} {
  grid-gap: 32px;
  margin-top: -30px;

  & > div {
    grid-column: span 6;
    border-radius: 8px;

  }
}

${({ theme }) => theme.mediaQueries.md} {
  grid-gap: 32px;
  margin-top: -30px;
  & > div {
    grid-column: span 6;
    border-radius: 8px;

  }
}
`

const Cards3 = styled(BaseLayout)`
align-items: stretch;
justify-content: stretch;
grid-gap: 24px;



& > div {
  grid-column: span 6;
  width: 100%;
}

${({ theme }) => theme.mediaQueries.sm} {

  & > div {
    grid-column: span 8;

  }
}

${({ theme }) => theme.mediaQueries.lg} {
  grid-gap: 32px;

  & > div {
    grid-column: span 6;

  }
}

${({ theme }) => theme.mediaQueries.md} {
  grid-gap: 32px;
  & > div {
    grid-column: span 6;

  }
}
`
const SalesCarousel = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const slideRef = useRef(null)

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 3)
    }, 5000)

    return () => clearInterval(slideInterval)
  }, [])

  useEffect(() => {
    slideRef.current.style.transform = `translateX(-${currentSlide * 100}%)`
  }, [currentSlide])

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % 3)
  }

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + 3) % 3)
  }

  return (
    <SliderContainer>
      <SliderWrapper ref={slideRef}>
        <Slide>
          <SalesSection3 {...data} />
        </Slide>
        <Slide>
          <SalesSection4 {...data} />
        </Slide>
        <Slide>
          <SalesSection5 {...data} />
        </Slide>
      </SliderWrapper>
      <NavButton className="prev" onClick={prevSlide}>‹</NavButton>
      <NavButton className="next" onClick={nextSlide}>›</NavButton>
    </SliderContainer>
  )
}

const Home: React.FC = () => {
  const { theme } = useTheme()
  const { account } = useWeb3React()
 
  const { isXs, isSm, isMd, isLg, isXl } = useMatchBreakpoints()

  const isMobile = !isXs
  const isMobile2 = !isSm
  const isMobile3 = !isMd
  const isMobile4 = !isLg
  const isMobile5 = !isXl

  const HomeSectionContainerStyles = { margin: '0', width: '100%', maxWidth: '968px' }

  return (
    <>
      <StyledHeroSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'rgba(0,0,0,0)'
            : 'rgba(0,0,0,0)'
        }
        index={2}
        hasCurvedDivider={false}
      >
        <SalesSection {...cakeSectionData} />
      </StyledHeroSection>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'rgba(0,0,0,0)'
            : 'rgba(0,0,0,0)'
        }
        index={2}
        hasCurvedDivider={false}
      >        <RoadmapSlider/> 
                    </PageSection>

              <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'rgba(0,0,0,0)'
            : 'rgba(0,0,0,0)'
        }
        index={2}
        hasCurvedDivider={false}
      >  

         <FarmsPoolsRow  />
              </PageSection>
              <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'rgba(0,0,0)'
            : 'rgba(0,0,0)'
        }
        index={2}
        hasCurvedDivider={false}
      > 
    <Flex  mb="20px"  >
<TopTokenMovers3 />
</Flex>

      {!isMobile &&
    <Flex flexDirection="column" justifyContent="center" alignItems="center" mr="-20px" mb="-20px"  >
        <SalesCarousel data={cakeSectionData2} />

 </Flex>
          }       
              {!isMobile2 &&
    <Flex flexDirection="column" justifyContent="center" alignItems="center" mr="-20px" mb="-20px">
        <SalesCarousel data={cakeSectionData2} />

 </Flex> 
          }      
            {!isMobile3 &&
    <Flex justifyContent="center" alignItems="center" mr="-20px" mb="-20px">
 <SalesSection3 {...cakeSectionData2} />
 <SalesSection4 {...cakeSectionData2} />
 <SalesSection5 {...cakeSectionData2} />
 </Flex>
          }   
               {!isMobile4 &&
    <Flex justifyContent="center" alignItems="center" mr="-20px" mb="-20px">
 <SalesSection3 {...cakeSectionData2} />
 <SalesSection4 {...cakeSectionData2} />
 <SalesSection5 {...cakeSectionData2} />
 </Flex>
          }    
               {!isMobile5 &&
    <Flex justifyContent="center" alignItems="center"  mr="-20px" mb="-20px" >
 <SalesSection3 {...cakeSectionData2} />
 <SalesSection4 {...cakeSectionData2} />
 <SalesSection5 {...cakeSectionData2} />
 </Flex>
          }           
              </PageSection>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'rgba(0,0,0)'
            : 'rgba(0,0,0)'
        }
        index={2}
        hasCurvedDivider={false}
      >  
 <Cards3>      
 <Carousel slides={[
              '/images/home/banner/21.png',
                  '/images/home/banner/banner505.jpg',
                '/images/home/banner/banner505.png',
              '/images/home/banner/banner00X.png',
            '/images/home/banner/banner006.png',
          '/images/home/banner/banner002.png',
        '/images/home/banner/banner005.png',
     ]}
    autoPlay
    controls
    defaultSlide={0}
    interval={5000}
/>   

<Chart /> 


          </Cards3>         
              </PageSection>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'rgba(0,0,0)'
            : 'rgba(0,0,0)'
        }
        index={2}
        hasCurvedDivider={false}
      >
       

        <Cards>     
        <YoutubeEmbed /> 
        <SalesSection0/>
        </Cards>
 
              </PageSection>
           
              <PageSection
      innerProps={{ style: { margin: '0', width: '100%' } }}
      background={
        theme.isDark
          ? 'rgba(0,0,0,0)'
          : 'rgba(0,0,0,0)'
      }
      index={2}
      hasCurvedDivider={false}
      >      
    <Flex flexDirection="column" justifyContent="center" alignItems="center" >
    <FarmsPoolsRowLoader  />
          <HVIDataRow2 /> 
         </Flex> 

      </PageSection> 
      <PageSection  
      innerProps={{ style: { margin: '0', width: '100%' } }}
      background={
        theme.isDark
          ? 'rgba(0,0,0)'
          : 'rgba(0,0,0)'
      }
      index={2}
      hasCurvedDivider={false}
      >      
        <Footer3 />
      </PageSection>
    </>
  )
}

export default Home
